import asyncComponent from '../common/utils/async-component';

const Billing = asyncComponent(async () => import('./components/billing'));

export default {
  '/billing': {
    components: { main: Billing }
  }
};
